import {
  WorkloadOptimizationAgentStatus,
  WorkloadOptimizationAgentStatusResponse,
} from '@cast/types';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';
import { useAnyActiveTourStepId } from 'core/tour-v2/hooks/useAnyActiveTourStepId';
import { useWorkloadOptimizationAgentStatusQuery } from 'hooks/queries/workload-optimization';

import { useCanViewWoop } from './useCanViewWoop';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useWorkloadOptimizationAgentStatus = () => {
  const { cluster } = useCluster();
  const canView = useCanViewWoop();
  const tourStepId = useAnyActiveTourStepId();
  const isClusterDemoMode = useIsClusterDemoMode();

  const shouldLoadFixture = (!canView && !isClusterDemoMode) || !!tourStepId;

  const queryResult = useWorkloadOptimizationAgentStatusQuery({
    clusterId: cluster.id,
    enabled: !shouldLoadFixture,
  });

  const agentStatusDataOrFixture = shouldLoadFixture
    ? ({
        status: WorkloadOptimizationAgentStatus.RUNNING,
        currentVersion: '1',
        latestVersion: '1',
        metricsExporterVersion: '1',
        castAgentCurrentVersion: '1',
        workloadAutoscalerReplicaCount: 1,
      } as WorkloadOptimizationAgentStatusResponse)
    : queryResult.data;

  return { ...queryResult, ...agentStatusDataOrFixture };
};
